import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface PetBasicInfoProps {
  name: string;
  breed: string;
  age: string;
  gender: string;
  size: string;
  color: string;
  adoptionStatus: 'available' | 'pending' | 'adopted';
}

const PetBasicInfo = ({
  name,
  breed,
  age,
  gender,
  size,
  color,
  adoptionStatus,
}: PetBasicInfoProps) => {
  const statusConfig = {
    available: {
      label: 'Available for Adoption',
      bgColor: 'bg-success',
      textColor: 'text-success-foreground',
      icon: 'CheckCircleIcon',
    },
    pending: {
      label: 'Adoption Pending',
      bgColor: 'bg-warning',
      textColor: 'text-warning-foreground',
      icon: 'ClockIcon',
    },
    adopted: {
      label: 'Adopted',
      bgColor: 'bg-muted',
      textColor: 'text-muted-foreground',
      icon: 'HeartIcon',
    },
  };

  const status = statusConfig[adoptionStatus];

  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-4xl md:text-5xl font-headline font-semibold text-foreground mb-2">
            {name}
          </h1>
          <p className="text-xl text-muted-foreground font-body">{breed}</p>
        </div>
        <div
          className={`flex items-center gap-2 px-4 py-2 rounded-full ${status.bgColor} ${status.textColor}`}
        >
          <Icon name={status.icon as any} size={20} variant="solid" />
          <span className="font-body font-medium">{status.label}</span>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        <div className="flex items-center gap-3 p-4 bg-card rounded-xl">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Icon name="CalendarIcon" size={24} variant="outline" className="text-primary" />
          </div>
          <div>
            <p className="text-sm text-muted-foreground font-body">Age</p>
            <p className="text-lg font-body font-medium text-foreground">{age}</p>
          </div>
        </div>

        <div className="flex items-center gap-3 p-4 bg-card rounded-xl">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Icon name="UserIcon" size={24} variant="outline" className="text-primary" />
          </div>
          <div>
            <p className="text-sm text-muted-foreground font-body">Gender</p>
            <p className="text-lg font-body font-medium text-foreground">{gender}</p>
          </div>
        </div>

        <div className="flex items-center gap-3 p-4 bg-card rounded-xl">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Icon name="ScaleIcon" size={24} variant="outline" className="text-primary" />
          </div>
          <div>
            <p className="text-sm text-muted-foreground font-body">Size</p>
            <p className="text-lg font-body font-medium text-foreground">{size}</p>
          </div>
        </div>

        <div className="flex items-center gap-3 p-4 bg-card rounded-xl">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Icon name="SwatchIcon" size={24} variant="outline" className="text-primary" />
          </div>
          <div>
            <p className="text-sm text-muted-foreground font-body">Color</p>
            <p className="text-lg font-body font-medium text-foreground">{color}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PetBasicInfo;